var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashyInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 47,
    fill: "#8ECDD6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3163_22831)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.0002,
    cy: 54,
    r: 39,
    fill: "#73A6AD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1594 74.3416L35.95 76.9349C35.7367 77.1091 35.4727 77.2014 35.1984 77.2014C34.5383 77.2014 34 76.6581 34 75.9919V47.6806C34 36.8152 42.7344 28 53.5 28C64.2656 28 73 36.8152 73 47.6806V75.9919C73 76.6581 72.4617 77.2014 71.8016 77.2014C71.5273 77.2014 71.2633 77.1091 71.05 76.9349L67.8406 74.3416C67.5055 74.0648 67.0789 73.9213 66.6422 73.9213C66.043 73.9213 65.4742 74.2083 65.1187 74.6901L61.3 79.8255C60.9953 80.2355 60.5078 80.4815 60 80.4815C59.4922 80.4815 59.0047 80.2355 58.7 79.8255L54.8 74.5773C54.4953 74.1673 54.0078 73.9213 53.5 73.9213C52.9922 73.9213 52.5047 74.1673 52.2 74.5773L48.3 79.8255C47.9953 80.2355 47.5078 80.4815 47 80.4815C46.4922 80.4815 46.0047 80.2355 45.7 79.8255L41.8812 74.6901C41.5156 74.2083 40.957 73.9213 40.3578 73.9213C39.9211 73.9213 39.5047 74.075 39.1695 74.3416H39.1594ZM50.25 47.6806C50.25 45.8663 48.7977 44.4005 47 44.4005C45.2023 44.4005 43.75 45.8663 43.75 47.6806C43.75 49.4949 45.2023 50.9606 47 50.9606C48.7977 50.9606 50.25 49.4949 50.25 47.6806ZM60 50.9606C61.7977 50.9606 63.25 49.4949 63.25 47.6806C63.25 45.8663 61.7977 44.4005 60 44.4005C58.2023 44.4005 56.75 45.8663 56.75 47.6806C56.75 49.4949 58.2023 50.9606 60 50.9606Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7592 46.0299C61.4642 39.418 53.5535 36.6691 47.0903 39.8901C40.627 43.1111 38.0587 51.0822 41.3538 57.6942C44.6489 64.3061 52.5596 67.055 59.0228 63.834C65.4861 60.613 68.0543 52.6419 64.7592 46.0299Z",
    fill: "#73A6AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9815 65.5556C64.4851 65.5556 73 57.1485 73 46.7778C73 36.4071 64.4851 28 53.9815 28C43.4778 28 34.963 36.4071 34.963 46.7778C34.963 57.1485 43.4778 65.5556 53.9815 65.5556Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8558 46.8276L63.3438 33.7778C66.5684 35.8775 68.9133 38.9814 69.9706 42.5492C71.0278 46.117 70.7305 49.9229 69.1304 53.3046C67.5302 56.6862 64.7285 59.4296 61.2128 61.0572C57.6971 62.6848 53.69 63.0936 49.8889 62.2124L53.8558 46.8276Z",
    fill: "#73A6AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9815 59.2964C61.2941 59.2964 67.2222 53.5838 67.2222 46.5371C67.2222 39.4903 61.2941 33.7778 53.9815 33.7778C46.6688 33.7778 40.7407 39.4903 40.7407 46.5371C40.7407 53.5838 46.6688 59.2964 53.9815 59.2964Z",
    fill: "#FEFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8889 62.1852H53.7407V48.7037H49.8889V62.1852Z",
    fill: "#73A6AD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.6667,
    cy: 47.2593,
    r: 3.37037,
    fill: "#73A6AD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 47.2593,
    r: 3.37037,
    fill: "#73A6AD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3163_22831",
    x: 0.000228882,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_3163_22831"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashyInCircle);
export default __webpack_public_path__ + "static/media/dashy-in-circle.69a74184a694ea73991f82cacdc83c56.svg";
export { ForwardRef as ReactComponent };